import {Component, Input, OnInit} from "@angular/core";
import {
    Aangifte, AangifteRapport, BokkzAlgDataService,
    IncomeTaxEntity, OpbouwWUO, SpecificatieWUO,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject, combineLatest,} from "rxjs";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-eindvermogen',
  templateUrl: './spec-eindvermogen.component.html',
  styleUrls: ['./spec-eindvermogen.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDialogModule,
    SharedUiButtonModule,
    SharedUiDetailsModule
  ]
})

export class SpecEindvermogenComponent implements OnInit {
    @Input() public id!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = {} as boolean;
    public partnerAangifte = {} as Aangifte;

    public focusedElementId: string | null = null;
    public dialogVisible = false;

    rapportFormGroup = this.fb.group<AangifteRapport>({});
    rapport = {} as AangifteRapport;
    partnerRapport = {} as AangifteRapport;
    aangifteRapport = {} as AangifteRapport;
    public eigenVermogenFg = {} as FormGroup;

    public formStructure: any;

    showDialog() {
        this.dialogVisible = true;
    }

    constructor(private fb: FormBuilder,
                public dataService: BokkzIbDataService,
                public dataAlgService: BokkzAlgDataService) {
        this.rapportFormGroup = this.fb.group<AangifteRapport>(({
            specificatieWuo: this.fb.group<SpecificatieWUO>(({
                opbouw: this.fb.group<OpbouwWUO>(({
                    eindstandKER: null as unknown as number,
                    eindstandHIR: null as unknown as number,
                    eindstandFOR: null as unknown as number,
                    totaleEindvermogen: null as unknown as number,
                } as OpbouwWUO))
            } as SpecificatieWUO))
        } as AangifteRapport));
        this.eigenVermogenFg = this.fb.group({
            eigenVermogenEindstand: null as unknown as number,
        });
    }

    public ngOnInit(): void {
        // Subscribe op incomeTaxEntity om wijzigingen meteen door te voeren
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            this.updateForm(); // Update formulier zodra incomeTaxEntity verandert
        });

        // Subscribe op partner, zodat een switch de juiste rapportgegevens laadt
        this.partner.subscribe((partner) => {
            this.partnerBoolean = partner;
            this.updateForm(); // Update formulier als de partner-switch verandert
        });

        // Combineer alle observables om eerste waarden in te laden
        combineLatest([
            this.dataService.aangifteRapport,
            this.dataService.partnerAangifteRapport
        ]).subscribe(([aangeverRapport, partnerRapport]) => {
            if (aangeverRapport) {
                this.aangifteRapport = aangeverRapport;
            }
            if (partnerRapport) {
                this.partnerRapport = partnerRapport;
            }
            this.updateForm(); // Formulier updaten na initiële data
        });

        // Zorg ervoor dat het formulier disabled is na het invullen
        this.disableFormGroup(this.rapportFormGroup);
        this.disableFormGroup(this.eigenVermogenFg);
    }

    updateForm() {
        this.rapportFormGroup.reset();

        const selectedRapport = this.partnerBoolean ? this.partnerRapport : this.aangifteRapport;

        this.rapportFormGroup.patchValue({
            specificatieWuo: {
                opbouw: {
                    eindstandKER: selectedRapport.specificatieWUO?.opbouw?.eindstandKER || 0,
                    eindstandHIR: selectedRapport.specificatieWUO?.opbouw?.eindstandHIR || 0,
                    eindstandFOR: selectedRapport.specificatieWUO?.opbouw?.eindstandFOR || 0,
                    totaleEindvermogen: selectedRapport.specificatieWUO?.opbouw?.totaleEindvermogen || 0,
                }
            }
        });

        this.eigenVermogenFg.patchValue({
            eigenVermogenEindstand: (selectedRapport.specificatieWUO?.opbouw?.totaleEindvermogen || 0) -
                (selectedRapport.specificatieWUO?.opbouw?.eindstandFOR || 0) -
                (selectedRapport.specificatieWUO?.opbouw?.eindstandKER || 0) -
                (selectedRapport.specificatieWUO?.opbouw?.eindstandHIR || 0)
        });
    }




    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

}

